module.exports = __webpack_public_path__ + "img/abstract_sermons.c03b1a9.webp";